import { create } from 'zustand';

interface ForgotPasswordState {
  email: string;
  setEmail: (email: string) => void;
  canResend: boolean;
  setCanResend: (canResend: boolean) => void;
}

export const useForgotPasswordStore = create<ForgotPasswordState>((set) => ({
  email: '',
  setEmail: (email) => set({ email }),
  canResend: true,
  setCanResend: (canResend) => set({ canResend }),
}));